export default interface InsuredValue {
  minLimit: number;
  average: number;
  maxLimit: number;
}

export function makeEmptyInsuredValues(): InsuredValue {
  return { minLimit: 0, average: 0, maxLimit: 0 };
}
